import React, {useState} from 'react';
import {Tabs} from 'antd';
import {useTranslation} from 'react-i18next';
import CustomerComplaintPanel from './components/CustomerComplaintPanel';
import PodAbnormalPanel from './components/PodAbnormalPanel';
import {WorkbenchMode} from './graphql/types/CustomerComplaintType';

/** 外层大 Tab：客诉在前，POD 待更新在后 */
enum IssueParcelCategory {
    COMPLAINT = 'COMPLAINT',
    POD = 'POD',
}

/**
 * Tab 声明表：每项声明 key、label i18n、以及在哪些 mode 下可见。
 * 「谁在什么视角显示」集中在此处一处声明，新增 tab / 调整可见性只改这张表。
 * POD 异常数据不支持按 warehouseId 查询，故仅 DSP 可见；wms / HQ 只看客诉。
 */
const CATEGORY_DEFS: Array<{
    key: IssueParcelCategory;
    labelKey: string;
    modes: WorkbenchMode[];
}> = [
    {
        key: IssueParcelCategory.COMPLAINT,
        labelKey: 'issueParcelWorkbench.category.complaint',
        modes: ['DSP', 'wms', 'HQ'],
    },
    {key: IssueParcelCategory.POD, labelKey: 'issueParcelWorkbench.category.pod', modes: ['DSP']},
];

interface IssueParcelWorkbenchPageProps {
    /**
     * 运行视角；默认 DSP（delivery 路由侧不传）。
     * wms 路由侧传 'wms'（仓库角色单仓只读），QC 路由侧传 'HQ'（总部全美只读）。
     */
    mode?: WorkbenchMode;
}

const IssueParcelWorkbenchPage: React.FC<IssueParcelWorkbenchPageProps> = ({mode = 'DSP'}) => {
    const {t} = useTranslation();
    // 当前 mode 下可见的 tab（POD tab 不可见时其面板不挂载，不会触发 POD 异常列表接口）
    const visibleCategories = CATEGORY_DEFS.filter((c) => c.modes.includes(mode));
    const [activeCategory, setActiveCategory] = useState<IssueParcelCategory>(
        IssueParcelCategory.COMPLAINT,
    );
    // 兜底：activeCategory 不在可见集合内时回落到第一个可见 tab
    const effectiveCategory = visibleCategories.some((c) => c.key === activeCategory)
        ? activeCategory
        : visibleCategories[0].key;

    return (
        <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-3 h-full flex flex-col">
            <Tabs
                activeKey={effectiveCategory}
                onChange={(key) => setActiveCategory(key as IssueParcelCategory)}
                items={visibleCategories.map((c) => ({key: c.key, label: t(c.labelKey)}))}
            />
            {effectiveCategory === IssueParcelCategory.COMPLAINT ? (
                <CustomerComplaintPanel mode={mode} />
            ) : (
                <PodAbnormalPanel />
            )}
        </div>
    );
};

export default IssueParcelWorkbenchPage;
